import React, {Fragment} from 'react'
import {cx} from '@emotion/css'
import styled from '@emotion/styled'

import {Text} from '@vio/atlas/Text'
import {cssTheme} from '@vio/atlas/themes'

interface Props {
  /** Array of string values that will be separated with dot */
  values: string[]
  /** If true, the list will be displayed in a single line */
  isSingleLine?: boolean
}

const Wrapper = styled.div`
  color: ${cssTheme.colors.content.neutral.secondary};
  &.--is-single-line {
    white-space: nowrap;
  }
`

export const DotSeparatedList = ({values, isSingleLine}: Props) => {
  return (
    <Wrapper className={cx(isSingleLine && '--is-single-line')}>
      {values
        .filter(value => !!value?.length)
        .map((value, index) => (
          <Fragment key={`${value}${index}`}>
            {index > 0 && (
              <Text variant="bodyXS" as="span">
                &nbsp;·&nbsp;
              </Text>
            )}
            <Text variant="bodyXS" as="span">
              {value}
            </Text>
          </Fragment>
        ))}
    </Wrapper>
  )
}
